"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var Index_1 = require("../../../components/base/Index");
var styles = require("../../../styles/ModelResultStyles");
var TestIds_1 = require("../../../util/TestIds");
var ModelResultOutcomePlot = function (_a) {
    var width = _a.width;
    var residual = (0, RootReducer_1.useAppSelector)(function (root) { return root.modelResult; }).residual;
    var error = React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'outcome-plot' });
    if (!residual) {
        return error;
    }
    var actualValues = residual.actualValues, predictedValues = residual.predictedValues;
    if (!actualValues || !predictedValues) {
        return error;
    }
    return (React.createElement("div", { className: styles.ChartContainer },
        React.createElement(prediction_model_results_viz_1.ScatterPlotComponent, { xAxisLabel: Localize_1.Messages.residualXLabel(), yAxisLabel: Localize_1.Messages.residualYLabel(), x: actualValues, y: predictedValues, show45DegreeLine: true, useSameAxisRange: true, legend: {
                result: Localize_1.Messages.residualLegendPrimary(),
                compareTo: Localize_1.Messages.residualLegendSecondary(),
            }, width: width, height: width })));
};
exports.default = ModelResultOutcomePlot;
//# sourceMappingURL=ModelResultOutcomePlot.js.map